import { useAsyncExecutor, useAsyncExecutor2 } from "async-executor-hook";
import { useState } from "react";
import { getErrorValueResponse } from "../../common/error/Error";

import loadingGreen from "../../images/loading_gray.gif";
import { FILE_FORMATS, HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { uploadFileToS3 } from "../../utils/s3Upload";
import { MainButton } from "../FileUploadImporterCredit/FileUploadImporterCreditStyles";
import FileUploadInput from "../FileUploadInput/FileUploadInput";
import { Container } from "../FileUploadMandateModal/FileUploadMandateModalStyles";
import Modal from "../Modal/Modal";

export const FileUploadCreditThirdModal = (props) => {
  const {
    onOutsideClick,
    selectedRuc,
    setShowModalThirdError,
    setMessageErrorThird,
    updateShowModal,
    setShowModalThirdSuccess,
    countPageRedirect,
    dateUrlQuotationQuoted,
    quotation_ids,
    clearShoppingCar,
  } = props;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const onFileChange = (files) => {
    setSelectedFiles(files);
  };

  const saveCreditThird = useAsyncExecutor(
    async (params: any) => {
      const { payerRucOption, selectedFiles, ruc, quotation_ids } = params;
      const files = await uploadFileToS3(
        "third-party-credit-authorization",
        selectedFiles,
        "autorizacion_uso_linea_credito_"
      );
      const body = {
        quotation_ids,
        credit_payment_detail: {
          payer_ruc_option: payerRucOption,
          credit_auth_doc: files[0],
          ruc,
        },
      };
      return networkBackendRequest(
        `/invoices/credit/`,
        HTTP_METHODS.POST,
        null,
        body
      ).then((response) => response.json());
    },
    {
      onSuccess: () => {
        getQuotationQuotedCredit.execute({ from_date: dateUrlQuotationQuoted });
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        clearShoppingCar();
        setMessageErrorThird(errorMessage);
        setShowModalThirdError(true);
        updateShowModal(false);
      },
    }
  );

  const getQuotationQuotedCredit: any = useAsyncExecutor2(
    (params: any) => {
      return networkBackendRequest("/quotations/quoted/", HTTP_METHODS.GET, {
        from_date: params.from_date,
      }).then((resp) => resp.json());
    },
    {
      onSuccess: (data) => {
        const count = data.count;
        countPageRedirect(count);
        setShowModalThirdSuccess(true);
        setSelectedFiles([]);
        updateShowModal(false);
      },
      onError: () => {
        countPageRedirect(1);
        setShowModalThirdSuccess(true);
        setSelectedFiles([]);
        updateShowModal(false);
      },
    }
  );

  return (
    <Modal onOutsideClick={onOutsideClick}>
      <Container>
        <h1>ADJUNTAR DOCUMENTO DE CRÉDITO DE OTROS</h1>
        <FileUploadInput
          maxFiles={1}
          onValueChange={onFileChange}
          value={selectedFiles}
          formats={[FILE_FORMATS.IMAGE, FILE_FORMATS.PDF]}
        />
        <MainButton
          disabled={
            selectedFiles.length === 0 ||
            saveCreditThird.isLoading ||
            getQuotationQuotedCredit.isLoading ||
            quotation_ids.length < 1
          }
          onClick={() => {
            saveCreditThird.execute({
              payerRucOption: "third_party_agency",
              selectedFiles: selectedFiles,
              ruc: selectedRuc,
              quotation_ids,
            });
          }}
        >
          {(saveCreditThird.isLoading ||
            getQuotationQuotedCredit.isLoading) && (
            <img src={loadingGreen} className="icon" alt="Processing request" />
          )}
          Enviar Documento
        </MainButton>
      </Container>
    </Modal>
  );
};
